import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Email } from '../../icons'
import { AppButton } from '..'
import ApplyParamsContext, { condenseParams } from '../../../context/ApplyParamsContext'
import { reloadIfCurrentRoute } from '../../../helpers/pageUtils'

function ContentfulButton({ data, isMain, onMouseOver, grid, bgImage, oldPimary, odsData }) {
  const {
    style,
    hasEmailIcon,
    text,
    action,
    url,
    contentfulAsset,
    openNewWindow,
    dataEvent,
    pageCategory
  } = data

  let buttonClass = ['button']

  const emailIcon = hasEmailIcon ? (
    <Email className={`button-group__icon button-group__icon-${style.toLowerCase()}`} />
  ) : null

  if (grid) {
    buttonClass.push('button--grid-card')
  }

  if (bgImage) {
    buttonClass.push('button--white')
  }

  if (style === 'Secondary') buttonClass.push('button--secondary')

  if (oldPimary) {
    buttonClass.push('button--primary')
  }

  if (isMain) {
    buttonClass.push('carousel-main')
  }

  buttonClass = buttonClass.join(' ')

  const productTypes = {
    Banking: 'banking',
    'Personal Loans Application': 'installment',
    'Credit Card Application': 'credit_card'
  }

  let textComp = text
  if (textComp?.length && textComp.indexOf('|') > -1) {
    textComp = textComp.split('|')
    textComp = (
      <>
        <span className="inactive">{textComp[0]}</span>
        <span className="active">{textComp[1]}</span>
      </>
    )
  }

  return (
    <ApplyParamsContext.Consumer>
      {applyParams => {
        if (productTypes[action]) {
          // ^ for cc and uloans only
          const { extraApplyParams } = condenseParams(applyParams)
          return (
            <AppButton
              className={odsData ? style : buttonClass}
              dataEvent={dataEvent}
              productType={productTypes[action]}
              pageCategory={pageCategory}
              landingKeyword={
                extraApplyParams && extraApplyParams.landing_keyword
                  ? extraApplyParams.landing_keyword
                  : null
              }
              extraApplyParams={extraApplyParams}
              odsData={odsData}
              onMouseOver={onMouseOver}
            >
              {emailIcon}
              {textComp}
            </AppButton>
          )
        }

        if (action === 'Email TextBox' || action[0] === 'Email TextBox') {
          return (
            <input
              type="text"
              placeholder="Email address"
              name="get_started_email"
              className="email"
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            />
          )
        }

        if (action === 'Contentful Asset' || action[0] === 'Contentful Asset') {
          return (
            <a
              href={contentfulAsset.file.url}
              download={contentfulAsset.file.filename}
              target="_blank"
              rel="noreferrer"
              className={buttonClass}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            >
              {emailIcon}
              {textComp}
            </a>
          )
        }

        if (openNewWindow) {
          // "Open URL"
          return (
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className={buttonClass}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            >
              {emailIcon}
              {textComp}
            </a>
          )
        }
        return (
          <Link
            to={url}
            className={buttonClass}
            onClick={() => reloadIfCurrentRoute(url)}
            onMouseOver={onMouseOver}
          >
            {emailIcon}
            {textComp}
          </Link>
        )
      }}
    </ApplyParamsContext.Consumer>
  )
}

ContentfulButton.defaultProps = {
  oldPimary: false,
  isMain: false,
  onMouseOver: null,
  odsData: undefined,
  grid: false,
  bgImage: false
}

ContentfulButton.propTypes = {
  data: PropTypes.object.isRequired,
  oldPimary: PropTypes.bool,
  isMain: PropTypes.bool,
  onMouseOver: PropTypes.func,
  odsData: PropTypes.func,
  grid: PropTypes.bool,
  bgImage: PropTypes.bool
}

export default ContentfulButton
